module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备ID:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "placeholder": "设备ID",
      "icon": "circle-close",
      "on-icon-click": _vm.cleanDevice
    },
    model: {
      value: (_vm.filters.deviceNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "deviceNo", $$v)
      },
      expression: "filters.deviceNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "掉线类型:"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": null
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("断线")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("信号差")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("设备故障")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "事件时间:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择时间",
      "align": "right"
    },
    model: {
      value: (_vm.filters.eventDate),
      callback: function($$v) {
        _vm.$set(_vm.filters, "eventDate", $$v)
      },
      expression: "filters.eventDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.logs,
      "border": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "deviceNo",
      "label": "设备ID",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "type",
      "formatter": _vm.formatType,
      "label": "掉线类型",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "eventDate",
      "formatter": _vm.formatTime,
      "label": "事件时间",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerName",
      "label": "客服姓名",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "remark",
      "label": "备注",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createdAt",
      "formatter": _vm.formatTime2,
      "label": "创建时间",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7866328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/ServiceLog.vue
// module id = 1320
// module chunks = 1